var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('floating-inner',[_c('div',{staticClass:"rounded overflow-hidden bg-white py-16"},[_c('p',{staticClass:"mb-8"},[_vm._v("ログアウトしました")]),_c('router-link',{attrs:{"to":{name: 'login'}}},[_vm._v("ログイン")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }